<template>
  <v-content>
    <v-container>
      <v-layout align-center justify-center my-12>
        <v-progress-circular
          :size="55"
          :width="4"
          color="primary"
          indeterminate
          v-if="loading"
        />

        <v-row
          v-if="notifications.length === 0 && !loading"
          align="center"
          justify="center"
        >
          <v-col cols="6" md="4" lg="4">
            <v-card class="text-center pa-5">
              <v-icon color="primary" x-large>mdi-bell</v-icon>
              <div class="headline mt-2">
                {{ $t("notifications.notification.noNotificationsAvailable") }}
              </div>
            </v-card>
          </v-col>
        </v-row>
        <v-card width="650" v-if="notifications.length !== 0">
          <div v-for="(notification, index) in notifications" :key="index">
            <notification
              :notification="notification"
              :id="notification.uuid"
              v-intersect.quiet="{
                handler: infiniteScrolling,
              }"
            ></notification>
            <v-divider inset></v-divider>
          </div>
        </v-card>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import Notification from "@/components/notifications/Notification.vue";
import api from "@/utils/api";
import { SOCKET_UPDATE_NOTIFIACTIONS_BADGE } from "@/store/actions/sockets";
import { mapGetters } from "vuex";

export default {
  components: { Notification },
  data() {
    return {
      notifications: [],
      loading: true,
      getUuid: null,
      nextUrl: null,
      seenNotificationsUuids: [],
    };
  },
  created() {
    this.getNotifications();
  },

  computed: {
    ...mapGetters(["getGlobalNotifications"]),
    globalNotifications() {
      return this.getGlobalNotifications.map((item) => {
        return {
          ...item,
          pinned: true,
          notif_type: "ANNOUNCEMENT",
          object_type: "ANNOUNCEMENT",
          seen: null,
          object_info: { crm_boat_uuid: null },
          created: item.start,
        };
      });
    },
  },

  beforeRouteLeave(to, from, next) {
    api
      .setSeenNotifications({
        crm_notification_uuids: this.seenNotificationsUuids.filter((item) => {
          return !this.globalNotifications.includes(item);
        }),
      })
      .then((resp) => {
        this.$store.commit(SOCKET_UPDATE_NOTIFIACTIONS_BADGE, {
          badge_count: resp.data.unread_notification_count,
        });
      });
    next();
  },

  methods: {
    getNotifications() {
      api.getNotifications().then((resp) => {
        if (
          resp.data.results.length === 0 &&
          this.globalNotifications.length === 0
        ) {
          this.notifications = [];
          this.loading = false;
          return;
        }

        this.seenNotificationsUuids = resp.data.results.map((item) => {
          return item.uuid;
        });

        this.notifications = resp.data.results.map((item) => {
          return { ...item, pinned: false };
        });
        if (resp.data.next) {
          this.getUuid = resp.data.results[resp.data.results.length - 2].uuid;
        }

        this.notifications = [
          ...this.globalNotifications,
          ...this.notifications,
        ];

        this.nextUrl = resp.data.next;
        this.loading = false;
      });
    },
    infiniteScrolling(entries, observer, isIntersecting) {
      if (entries[0].target.id === this.getUuid) {
        let path = this.nextUrl.split("/").splice(5, 5).join("/");

        api.getNotificationsNextPage(path).then((resp) => {
          this.getNextPage(resp);
          this.notifications = [...this.notifications, ...resp.data.results];
        });
      }

      this.seenNotificationsUuids = [
        ...new Set([...this.seenNotificationsUuids, entries[0].target.id]),
      ];
    },
    getNextPage(resp) {
      if (resp.data.next) {
        this.getUuid = resp.data.results[resp.data.results.length - 2].uuid;
        this.nextUrl = resp.data.next;
      } else {
        this.getUuid = null;
      }
    },
  },
};
</script>
